export default {
  INIT: 0,
  LOADING: 1,
  LOADED: 2
};



// WEBPACK FOOTER //
// ./src/store/loading-constants.js